// Thin fetch wrapper that attaches the access token and transparently retries
// once via a silent token refresh if a call comes back 401.
import { getAccessToken, refreshAccessToken } from './auth';

const API_BASE = process.env.VUE_APP_API_BASE_URL || '';

export async function apiFetch(path, options = {}) {
  const url = path.startsWith('http') ? path : `${API_BASE}${path}`;

  const doFetch = (token) => {
    const headers = { ...(options.headers || {}) };
    if (token) headers.Authorization = `Bearer ${token}`;
    return fetch(url, { ...options, headers });
  };

  const response = await doFetch(getAccessToken());
  if (response.status !== 401) return response;

  const newToken = await refreshAccessToken();
  if (!newToken) return response; // refreshAccessToken() already logged the user out if needed

  return doFetch(newToken);
}
